import { AnyAction, Dispatch } from 'redux';
import { SortChartData } from '../../../redux/ChartPoperties/ChartControlsActions';
import { sortChartData } from '../../ChartAxes/chartDataFunctions/sortChartData';
import { getNameFromUid } from '../../CommonFunctions/CommonFunctions';

export const filterShowHideData = (
  prop: string,
  dispatch: Dispatch<AnyAction>,
  descendingChartData: any,
  propKey: string,
  value: string | number,
  chartControls: any,
  chartProp: any,
  showHideValue?: string,
) => {
  let dummy: any = descendingChartData;
  let filteredData: any[] = [];

  const showHide = chartControls.properties[propKey]?.showHide?.isShow ? 'show' : 'hide';

  if (chartProp.properties[propKey].chartAxes) {
    // Rename fields before filtering or sorting
    dummy = sortChartData(dummy, chartProp.properties[propKey], chartControls, propKey);
    descendingChartData = sortChartData(
      descendingChartData,
      chartProp.properties[propKey],
      chartControls,
      propKey,
    );
  }

  // Apply filter logic
  const fullString = getNameFromUid(
    chartProp.properties[propKey].chartAxes,
    chartControls?.properties[propKey]?.showHide?.measureName,
  );

  if ((showHideValue ? showHideValue === 'show' : showHide === 'show') && value !== '') {
    if (prop === '> Greater than') {
      filteredData = dummy.filter((item: any) => item[fullString] > Number(value));
    } else if (prop === '< Less than') {
      filteredData = dummy.filter((item: any) => item[fullString] < Number(value));
    } else if (prop === '>= Greater than or Equal to') {
      filteredData = dummy.filter((item: any) => item[fullString] >= Number(value));
    } else if (prop === '<= Less than or Equal to') {
      filteredData = dummy.filter((item: any) => item[fullString] <= Number(value));
    } else {
      filteredData = dummy.filter((item: any) => item[fullString] === Number(value));
    }
  } else if ((showHideValue ? showHideValue === 'hide' : showHide === 'hide') && value !== '') {
    if (prop === '> Greater than') {
      filteredData = dummy.filter((item: any) => item[fullString] <= Number(value));
    } else if (prop === '< Less than') {
      filteredData = dummy.filter((item: any) => item[fullString] >= Number(value));
    } else if (prop === '>= Greater than or Equal to') {
      filteredData = dummy.filter((item: any) => item[fullString] < Number(value));
    } else if (prop === '<= Less than or Equal to') {
      filteredData = dummy.filter((item: any) => item[fullString] > Number(value));
    } else {
      filteredData = dummy.filter((item: any) => item[fullString] !== Number(value));
    }
  }
  // If there's a non-empty filtered data set, dispatch SortChartData with it
  // if we have filtered data length 0 and there is some higher value applied then it should show nothing in canvas. So in that case we need to go in if condition.
  if (fullString && (filteredData.length > 0 || (value !== '' && filteredData.length < 1))) {
    dispatch(SortChartData(propKey, filteredData));
  } else {
    dispatch(SortChartData(propKey, descendingChartData));
  }
};
